import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button, DialogActions, DialogContent, IconButton, Link, Menu, MenuItem } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

export default function PrimarySearchAppBar() {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);


  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(true);
    setAnchorEl(null);
  };

   return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            Konferencje
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>Kontakt</MenuItem>
                <Dialog open={open} onClose={() => setOpen(false)}>
                  <DialogTitle>Kontakt</DialogTitle>
                  <DialogContent dividers>
                    Adres e-mail: <Link href="mailto:mateusz2357b@gmail.com">mateusz2357b@gmail.com</Link>
                  </DialogContent>
                  <DialogActions>
                  <Button onClick={() => setOpen(false)}>Zamknij</Button>
                  </DialogActions>
                </Dialog>
              </Menu>
            </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}